export default function getTokenName() {
	let host = window.location.host;
	if (host.includes("demo.")) {
		return "demo_token";
	}
	return "token";
}
